import type { HierarchyResult, HierarchyNode } from '../../types';

// Simple wrapper around HierarchyResult to add convenience methods
export class HierarchyData {
  private readonly nodeMap: Map<string, HierarchyNode>;

  constructor(private readonly hierarchyResult: HierarchyResult) {
    // Create a lookup map for O(1) access instead of O(n) searches
    this.nodeMap = new Map();
    Object.values(hierarchyResult.nodes).forEach((node: any) => {
      this.nodeMap.set(node.record.recordId, node);
    });
  }

  getNodeByRecordId(recordId: string): HierarchyNode | undefined {
    return this.nodeMap.get(recordId);
  }

  get nodes(): Record<string, HierarchyNode> {
    return this.hierarchyResult.nodes;
  }

  get original(): HierarchyResult {
    return this.hierarchyResult;
  }
}
